import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import SimpleApiExplorer from '../components/SimpleApiExplorer';
import './PageStyles.css';

const KYC = () => {
  const [showTryApi, setShowTryApi] = useState(false);
  const kycRecords = [
    { id: 1, customerId: 'CUST001', customerName: 'John Doe', status: 'Verified', verificationDate: '2024-01-10', documents: ['ID Proof', 'Address Proof'], riskLevel: 'Low' },
    { id: 2, customerId: 'CUST002', customerName: 'Jane Smith', status: 'Verified', verificationDate: '2024-01-11', documents: ['ID Proof', 'Address Proof', 'Source of Funds'], riskLevel: 'Low' },
    { id: 3, customerId: 'CUST003', customerName: 'Bob Johnson', status: 'Pending', verificationDate: '-', documents: ['ID Proof'], riskLevel: 'Medium' },
    { id: 4, customerId: 'CUST004', customerName: 'Alice Brown', status: 'Verified', verificationDate: '2024-01-13', documents: ['ID Proof', 'Address Proof'], riskLevel: 'Low' },
    { id: 5, customerId: 'CUST005', customerName: 'Charlie Wilson', status: 'Rejected', verificationDate: '2024-01-12', documents: ['ID Proof'], riskLevel: 'High' },
  ];

  const sampleRequest = {
    customer_id: "CUST006",
    document_type: "id_proof",
    document_number: "DL123456789",
    document_file: "base64_encoded_file",
    additional_info: {
      country: "US",
      issue_date: "2020-01-15",
      expiry_date: "2025-01-15"
    }
  };

  const sampleResponse = {
    status: "success",
    code: "200",
    message: "KYC document submitted successfully",
    data: {
      kyc_id: 6,
      customer_id: "CUST006",
      status: "pending",
      document_type: "id_proof",
      submitted_at: "2024-01-15T10:30:00Z",
      estimated_verification_time: "24-48 hours"
    },
    request_id: "req_123456789"
  };

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>KYC Records</h2>
            <button type="button" className="btn btn-secondary" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Customer ID</th>
                <th>Customer Name</th>
                <th>Status</th>
                <th>Risk Level</th>
                <th>Documents</th>
                <th>Verification Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {kycRecords.map((record) => (
                <tr key={record.id}>
                  <td>{record.id}</td>
                  <td>{record.customerId}</td>
                  <td><strong>{record.customerName}</strong></td>
                  <td>
                    <span className={`status-badge ${record.status.toLowerCase()}`}>
                      {record.status}
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${record.riskLevel.toLowerCase()}`}>
                      {record.riskLevel}
                    </span>
                  </td>
                  <td>{record.documents.join(', ')}</td>
                  <td>{record.verificationDate}</td>
                  <td>
                    <button className="btn btn-success btn-sm">View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <SimpleApiExplorer
              apiName="KYC API"
              endpoint="/api/v1/kyc/submit"
              method="POST"
              sampleRequest={sampleRequest}
              sampleResponse={sampleResponse}
              onClose={() => setShowTryApi(false)}
            />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default KYC;
